import i18n from '@/plugins/vue-i18n'

export default {
  validate: (v) => {
    const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,})/
    const regex = new RegExp(urlRegex)
    return (v && regex.test(v)) || i18n.t('validation.url')
  }
}
